import { ErrorHandler, Injectable } from '@angular/core';
import { isBaseError } from './base-error';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: unknown): void {
        if (isBaseError(error)) {
            console.error(`[${error.name}] ${error.message}`, {
                code: error.code,
                errorHash: error.errorHash,
                cause: error.cause,
            });
            return;
        }

        console.error(error);
    }
}
